var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnEventStar = function SvgIcnEventStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5169 9.8118L17.0569 12.8918C17.2669 13.3118 17.8269 13.7318 18.2936 13.8018L21.0819 14.2685C22.8669 14.5718 23.2869 15.8551 22.0036 17.1385L19.8336 19.3085C19.4719 19.6701 19.2619 20.3818 19.3786 20.8951L19.9969 23.5901C20.4869 25.7135 19.3553 26.5418 17.4769 25.4335L14.8636 23.8818C14.3852 23.6018 13.6153 23.6018 13.1369 23.8818L10.5236 25.4335C8.64523 26.5418 7.51356 25.7135 8.00356 23.5901L8.62193 20.8951C8.7386 20.3935 8.52858 19.6818 8.16691 19.3085L5.99693 17.1385C4.7136 15.8551 5.13357 14.5601 6.91857 14.2685L9.70692 13.8018C10.1736 13.7201 10.7336 13.3118 10.9436 12.8918L12.4836 9.8118C13.3119 8.14346 14.6886 8.14346 15.5169 9.8118Z",
    stroke: "#57595E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.8506V2.6839",
    stroke: "#57595E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.8506V2.6839",
    stroke: "#57595E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.01723V2.6839",
    stroke: "#57595E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnEventStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_event_star.a33200b1.svg";
export { ForwardRef as ReactComponent };